/** @jsxImportSource @emotion/react */
import { FC, useState } from 'react';
import { Box, Grid } from '@mui/material';

const footer = {
	height: "60px",
	background: "#F1F1F1",
	display: "flex",
	width: "100%",
	bottom:0,
	justifyContent: "end",
	alignItems: "center",
		
}
const footerText = {
	marginLeft: "auto",
	textAligin:"center"
}

export const Layout: FC = ({ children }) => {
	return (
			<Box component='main'>
				{children}
					<Grid container  sx={footer} mt={8}>
						<Grid item lg={6}  md={11} sm={11} xs={12} sx={footerText} style={{'textAlign':'center'}}>
							Copyright © Freshworks Inc. All Rights Reserved 
						</Grid>
					</Grid>
			</Box>
	)
			
};
